export const NAME = 'search-map';

export const MAP_NUM_INITIALLY_SELECTED_TYPES = 2;
